import LottiePlayer from "./animationPlayer";
import "./css/coursePageHead.css";

const HeroSection = () => {
  return (
    <div className="hero-container">
      {/* <video autoPlay muted loop playsInline className="background-video">
        <source src="/Students/course-banner-mp4.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}

      {/* Content */}
      <div className="content-wrapper">
        <div className="main-content-row">
          <div className="text-content">
            <p className="hero-heading">Still confused about your career?</p>
            <p className="hero-heading">Let us help you out!!!</p>
            <p className="hero-description">
              Here at YAPASSIO we guide you towards a passionate career aligned
              with your Skill, Knowledge, Behaviour, IQ, Decision Making,
              Emotional Intelligence and Aptitude
            </p>
          </div>
          <div className="animation-container">
            <LottiePlayer animationPath={"/json/coursePage3.json"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
